module.exports = __webpack_public_path__ + "media/Champions.e99a73d1.mp3";